'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _helpers = require('@adparlor-devops/js-anvil/helpers');

var _actions = require('../../../store/events/actions');

var _selectors = require('../../../store/events/selectors');

var _Activity = require('../components/Activity');

var _Activity2 = _interopRequireDefault(_Activity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    filters: (0, _selectors.getFilter)(state),
    aggregateEventUpdateAvailable: state.events.aggregateEventUpdateAvailable
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    createAction: (0, _helpers.buildActionsCollection)({
      fetchAggregateEvents: _actions.fetchAggregateEvents
    }, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Activity2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/modules/Activity/containers/ActivityContainer.js
// module id = 3394
// module chunks = 2